/**
 * Store Pinia — dialog
 *
 * Migré depuis `store/modules/dialog.js`. Gère le dialog global (reçu, message HTML).
 * Non persisté.
 *
 * Équivalences Vuex → Pinia :
 *   - getters.getDialogInfo → getters.getDialogInfo
 *   - mutations.showDialog  → actions.showDialog
 *   - mutations.hideDialog  → actions.hideDialog
 */
import { defineStore } from 'pinia'

export const useDialogStore = defineStore('dialog', {
  state: () => ({
    info: {
      show: false,
      message: '',
      print: false,
      html: false,
      iconState: false,
      iconColor: null,
      iconName: null,
    },
  }),

  getters: {
    getDialogInfo: (state) => state.info,
  },

  actions: {
    showDialog (payload) {
      this.info = payload
      this.info.show = true
    },
    hideDialog () {
      this.info.show = false
    },
  },
})
